export default __webpack_public_path__ + "public/images/developer-header.jpeg?5dd499b6";